import { useMemo } from "react";

export interface GridColumn {
    width: number;
    type?: 'fr' | 'px';
}

interface GridSettings {
    columns: GridColumn[];
}

/** Component used this hook should extend its props interface from this interface */
export interface IBaseGridStyle {
    settings: GridSettings;
    columns: React.ReactNode[];
}

interface IResultStyle {
    gridTemplateColumns: string;
}

/** converts grid stteings to styles */
export function getGridTemplateColumnsStyle(settings: GridSettings, columns: React.ReactNode[] = []): IResultStyle {
    const colSizes = settings.columns.map(s => `${s.width}${s.type ?? 'fr'}`);
    const missingCols = columns.length - colSizes.length;
    for (let i = 0; i < missingCols; i++) {
        colSizes.push(`1fr`);
    }
    return {
        gridTemplateColumns: colSizes.join(' '),
    }
}

export function useGridStyleHook(settings: GridSettings, columns: React.ReactNode[]) {
    return useMemo(() => getGridTemplateColumnsStyle(settings, columns), [settings, columns]);
}
